module.exports = __webpack_public_path__ + "moldova.svg?9916d222044bae66879f743b5b759646";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/moldova.svg
// module id = 233
// module chunks = 10